import React, { useState, useEffect } from "react";
import { Link, Toolbar, f7 } from "framework7-react";
import './MainToolBar.css';
import {useTranslation} from "react-i18next";

export const MainToolBar = () => {
    const f7app = f7;
    const { t } = useTranslation();
    const [currentPath, setCurrentPath] = useState(f7.views.main?.router?.currentRoute?.path || "/");

    useEffect(() => {
        const updatePath = () => {
            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
            }
            setCurrentPath(f7.views.main?.router?.currentRoute?.path || "/");
        };

        f7app.on("routeChange", updatePath);
        updatePath();

        return () => {
            f7app.off("routeChange", updatePath);
        };
    }, []);


    return (
        <Toolbar tabbar position="bottom" className="toolbar-bottom">
            <Link
                href="/"
                text={`${t("navigation.home")}`}
                tabLinkActive={currentPath === "/"}
                transition="f7-push"
            />
            <Link
                href="/tickets/"
                text={`${t("navigation.earnMoney")}`}
                tabLinkActive={currentPath === "/tickets/"}
                transition="f7-push"
            />
            <Link
                href="/profile/"
                text={`${t("navigation.profile")}`}
                tabLinkActive={currentPath === "/profile/"}
                transition="f7-push"
            />
        </Toolbar>
    );
};
